var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-container"},[(!_vm.step || _vm.step === 1)?_c('CheckPassword',{on:{"changeStep":_vm.changeStep}}):_vm._e(),(_vm.step === 2)?_c('UserLeaveForm'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }